export const parseJson = (jsonString) => {
    const result = {
        success: false,
        data: null,
        error: null,
        isEmpty: false
    }
    if (!jsonString || jsonString.trim() === '') {
        result.isEmpty = true;
        result.success = true; // Empty is considered "successful"
        return result;
    }
    try {
        result.data = JSON.parse(jsonString)
        result.success = true;
    }
    catch (e) {
        result.success = false
        result.data = null
        result.error = e
    }
    return result
}

/**
 * Recursively finds the index path of a task by its reference name in a nested task structure
 * @param {Array} tasks - Array of task objects to search through
 * @param {string} taskReferenceName - The reference name of the task to find
 * @returns {Array|null} - Array representing the path to the task (e.g., [0, "decisionCases", "case1", 2]) or null if not found
 */
export const findTaskIndex = (tasks, taskReferenceName) => {
    for (let i = 0; i < tasks.length; i++) {
        if (tasks[i].taskReferenceName === taskReferenceName) {
            return [i];
        }

        // Check nested decision cases
        if (tasks[i].decisionCases) {
            for (const key in tasks[i].decisionCases) {
                const decisionIndex = findTaskIndex(tasks[i].decisionCases[key], taskReferenceName);
                if (decisionIndex) {
                    return [i, "decisionCases", key, ...decisionIndex];
                }
            }
        }

        // Check default case
        if (tasks[i].defaultCase) {
            const defaultIndex = findTaskIndex(tasks[i].defaultCase, taskReferenceName);
            if (defaultIndex) {
                return [i, "defaultCase", ...defaultIndex];
            }
        }

        // Check loop over tasks
        if (tasks[i].loopOver) {
            const loopOverIndex = findTaskIndex(tasks[i].loopOver, taskReferenceName);
            if (loopOverIndex) {
                return [i, "loopOver", ...loopOverIndex];
            }
        }

        // Check fork tasks (array of arrays)
        if (tasks[i].forkTasks) {
            for (let j = 0; j < tasks[i].forkTasks.length; j++) {
                const forkIndex = findTaskIndex(tasks[i].forkTasks[j], taskReferenceName);
                if (forkIndex) {
                    return [i, "forkTasks", j, ...forkIndex];
                }
            }
        }
    }

    return null;
}

/**
 * Recursively adds isSubWF flag to a task and all its nested tasks
 * @param {Object} task - Task object to process
 * @returns {Object} - New task object with isSubWF flag added to all nested structures
 */
export const addIsSubWFFlag = (task) => {
    const modifiedTask = { ...task, isSubWF: true };

    if (modifiedTask.decisionCases) {
        Object.keys(modifiedTask.decisionCases).forEach((key) => {
            modifiedTask.decisionCases[key] = modifiedTask.decisionCases[key].map(addIsSubWFFlag);
        });
    }

    ["defaultCase", "loopOver", "forkTasks"].forEach((key) => {
        if (modifiedTask[key]) {
            modifiedTask[key] = modifiedTask[key].map(addIsSubWFFlag);
        }
    });

    if (modifiedTask.forkTasks) {
        modifiedTask.forkTasks = modifiedTask.forkTasks.map((tasks) =>
            tasks.map(addIsSubWFFlag)
        );
    }

    return modifiedTask;
}
export const isValidWorkflowName = (name) => {
    return name &&
        name !== 'undefined' &&
        name !== 'null' &&
        name !== undefined &&
        name !== null;
};
